import * as Preact from "preact"
import App from "@frog/source/models/App.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import Random from "@frog/source/utility/Random.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import Zone from "@frog/source/models/Zone.js"
import Step from "@frog/source/models/Step.js"
import World from "@frog/source/models/World.js"

import player from "@frog/source/data/games/pirates/player.js"
const PLAYER_CHARACTER = "swashbuckler"


export default {
    "slug": "ship",
    "hasPreparePhase": false,
    "startingEncounter": "1.1",

    "stage": {
        "units": require("./units.json"),
        "world": World.parse({
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "encounters": require("./encounters.json"),
        }),
        "configuration": {
            "darkness": "none",
        },
        "images": [
            require("./ship1.png"),
            require("./ship2.png"),
            require("./ship3.png"),
        ],
        "text": function(stage) {
            if(stage.flags["hud"] == "hidden") {
                return (
                    <div class="TutorialPrompt" isHidden={true}/>
                )
            }
            if(stage.currentEncounterKey == "1.1") {
                if(stage.flags["tutorial:hasMovedWithoutAttacking"] == true) {
                    return (
                        <div class="TutorialPrompt" position="topright">
                            <div class="Text">If need be, you can always undo.</div>
                        </div>
                    )
                }
                if(stage.flags["tutorial:hasAttacked"] != true) {
                    return (
                        <div class="TutorialPrompt" position="topright">
                            <div class="Text">You've been given a sword. Let's put it to use.</div>
                        </div>
                    )
                }
                if(stage.flags["tutorial:hasKilled"] == true) {
                    return (
                        <div class="TutorialPrompt" position="topright">
                            <div class="Text">Excellent. Now end your turn. Let them come to you.</div>
                        </div>
                    )
                }
            }
            if(stage.currentEncounterKey == "1.2") {
                if(stage.flags["tutorial:hasAttacked"] != true) {
                    return (
                        <div class="TutorialPrompt" position="topright">
                            <div class="Text">The guards here are heavily armored, but it makes them slow. Hover over them to see their range.</div>
                        </div>
                    )
                }
            }

            if(stage.currentEncounterKey == "1.3") {
                if(stage.flags["tutorial:hasAttacked"] != true) {
                    return (
                        <div class="TutorialPrompt" position="topright">
                            <div class="Text">This soldier wields a ranged weapon. Best close the gap!!</div>
                        </div>
                    )
                }
                if(stage.flags["tutorial:hasBeenAttacked"] == true) {
                    return (
                        <div class="TutorialPrompt" position="topright">
                            <div class="Text">Because they attacked at long range, YOU cannot counterattack with your sword.</div>
                        </div>
                    )
                }
                if(stage.flags["tutorial:hasAttacked"] == true) {
                    return (
                        <div class="TutorialPrompt" position="bottomright">
                            <div class="Text">Because you attacked at close range, they can't counterattack with their bow.</div>
                        </div>
                    )
                }
            }

            if(stage.currentEncounterKey == "2.3") {
                if(stage.flags["tutorial:hasBeenAttackedInCounterattack"] == true) {
                    return (
                        <div class="TutorialPrompt" position="bottomright">
                            <div class="Text">
                                Ouch! That was half your health! You can always
                                hit the undo button and try approaching it differently.
                            </div>
                        </div>
                    )
                }
            }

            if(stage.currentEncounterKey == "2.2") {
                if(stage.flags["tutorial:hasAttackedEffectivelyWithEarth"] == true) {
                    return (
                        <div class="TutorialPrompt" position="bottomright">
                            <div class="Text">
                                The <span class="green">green weapons</span> cleave
                                through the <span class="blue">blue armor</span>!
                            </div>
                        </div>
                    )
                }
                if(stage.flags["tutorial:hasAttackedIneffectively"] == true) {
                    return (
                        <div class="TutorialPrompt" position="bottomright">
                            <div class="Text">
                                Our <span class="red">swords</span> are
                                weak to their <span class="blue">spears</span>,
                                and don't do as much damage.
                                <br/><br/>
                                If need be, we can always undo.
                            </div>
                        </div>
                    )
                }
                return (
                    <div class="TutorialPrompt" position="topright">
                        <div class="Text">
                            These pirates wield <span class="blue">blue</span> spears.
                            <br/><br/>
                            <span class="blue">Blue</span> beats <span class="red">red</span>,
                            but <span class="green">green</span> beats <span class="blue">blue</span>!
                        </div>
                    </div>
                )
            }

            if(stage.currentEncounterKey == "2.1") {
                if(stage.flags["tutorial:AttackerColor"] == "red"
                && stage.flags["tutorial:AttackedColor"] == "red") {
                    return (
                        <div class="TutorialPrompt" position="bottomright">
                            <div class="Text">
                                If you attack the same color, like <span class="red">Red</span> on <span class="red">Red</span>, you deal a neutral 20 damage.
                            </div>
                        </div>
                    )
                }
                if(stage.flags["tutorial:AttackerColor"] == "green"
                && stage.flags["tutorial:AttackedColor"] == "green") {
                    return (
                        <div class="TutorialPrompt" position="bottomright">
                            <div class="Text">
                                If you attack the same color, like <span class="green">Green</span> on <span class="green">Green</span>, you deal a neutral 20 damage.
                            </div>
                        </div>
                    )
                }
                if(stage.flags["tutorial:AttackerColor"] == "blue"
                && stage.flags["tutorial:AttackedColor"] == "blue") {
                    return (
                        <div class="TutorialPrompt" position="bottomright">
                            <div class="Text">
                                If you attack the same color, like <span class="blue">Blue</span> on <span class="blue">Blue</span>, you deal a neutral 20 damage.
                            </div>
                        </div>
                    )
                }
                if(stage.flags["tutorial:AttackerColor"] == "red"
                && stage.flags["tutorial:AttackedColor"] == "blue") {
                    return (
                        <div class="TutorialPrompt" position="bottomright">
                            <div class="Text">
                                The <span class="red">Red</span> is weak to <span class="blue">Blue</span>, so you deal a weak 15 damage. You can always undo if need be!
                            </div>
                        </div>
                    )
                }
                if(stage.flags["tutorial:AttackerColor"] == "blue"
                && stage.flags["tutorial:AttackedColor"] == "green") {
                    return (
                        <div class="TutorialPrompt" position="bottomright">
                            <div class="Text">
                                <span class="blue">Blue</span> is weak to <span class="green">Green</span>, so you deal a weak 15 damage. You can always undo if need be!
                            </div>
                        </div>
                    )
                }
                if(stage.flags["tutorial:AttackerColor"] == "green"
                && stage.flags["tutorial:AttackedColor"] == "red") {
                    return (
                        <div class="TutorialPrompt" position="bottomright">
                            <div class="Text">
                                <span class="green">Green</span> is weak to <span class="red">Red</span>, so you deal a weak 15 damage. You can always undo if need be!
                            </div>
                        </div>
                    )
                }
                if(stage.flags["tutorial:AttackerColor"] == "red"
                && stage.flags["tutorial:AttackedColor"] == "green") {
                    return (
                        <div class="TutorialPrompt" position="bottomright">
                            <div class="Text">
                                <span class="red">Red</span> is strong to <span class="green">Green</span>, so you attack twice, dealing 30 damage! Very nice!!
                            </div>
                        </div>
                    )
                }
                if(stage.flags["tutorial:AttackerColor"] == "green"
                && stage.flags["tutorial:AttackedColor"] == "blue") {
                    return (
                        <div class="TutorialPrompt" position="bottomright">
                            <div class="Text">
                                <span class="green">Green</span> is strong to <span class="blue">Blue</span>, so you attack twice, dealing 30 damage! Very nice!!
                            </div>
                        </div>
                    )
                }
                if(stage.flags["tutorial:AttackerColor"] == "blue"
                && stage.flags["tutorial:AttackedColor"] == "red") {
                    return (
                        <div class="TutorialPrompt" position="bottomright">
                            <div class="Text">
                                <span class="blue">Blue</span> is strong to <span class="red">Red</span>, so you attack twice, dealing 30 damage! Very nice!!
                            </div>
                        </div>
                    )
                }
            }

            return (
                <div class="TutorialPrompt" isHidden={true}/>
            )
        },
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    PlotSteps.ReportStartingAnalytics(),
                    PlotSteps.KillAudio({"label": "music"}),
                    PlotSteps.PlayAudio("Pirate:Ambience:Boat"),
                    Step.flag("hud", "hidden"),
                    PlotSteps.ChapterStart([
                        "Chapter 1",
                        "The Stowaway",
                        "In Which",
                        "Eleanor comandeers a ship",
                        "with the help of some old friends"
                    ]),
                    "KNIGHT: ENTERS 4",
                    "KNIGHT: #direction: left",
                    "KNIGHT: You fought well, but not well enough.",
                    "KNIGHT: Any last words?",
                    "SWASHBUCKLER: ENTERS 1",
                    "SWASHBUCKLER: Maybe someday. #expression: wink",
                    "SWASHBUCKLER: #expression: neutral",
                    "KNIGHT: Throw her overboard. #expression: angry",
                    "SQUIRE: ENTERS 3",
                    "SQUIRE: Aye aye, captain! #direction: left",
                    "KNIGHT: EXITS",

                    // PlotSteps.Wait(500),
                    // PlotSteps.MoveUnit({"unitKey": "knight", "position": {"x": 29, "y": 41}}),
                    // PlotSteps.MoveUnit({"unitKey": "knight", "position": {"x": 30, "y": 41}}),
                    // PlotSteps.TeleportUnit({"unitKey": "knight", "position": {"x": 22, "y": 20}}),
                    // PlotSteps.Wait(500),

                    "SWASHBUCKLER: ENTERS 1",
                    "SQUIRE: ENTERS 3",
                    "SQUIRE: #direction: left",
                    "SQUIRE: You, follow me-",

                    "SWINDLER: ENTERS 4",
                    "SWINDLER: #direction: left",
                    "SWINDLER: Just a moment, please.",

                    // PlotSteps.Wait(500),
                    // PlotSteps.MoveUnit({"unitKey": "swindler", "position": {"x": 26, "y": 44}}),
                    // PlotSteps.MoveUnit({"unitKey": "swindler", "position": {"x": 25, "y": 44}}),
                    // PlotSteps.Wait(500),

                    "SWINDLER: ENTERS 4",
                    "SWASHBUCKLER: ENTERS 1",
                    "SWINDLER: #direction: left",
                    "SWINDLER: #expression: smooth",
                    "SWINDLER: Excuse me, are you lost?",
                    "SWASHBUCKLER: Just get me out of here. #expression: challenge",
                    "SWINDLER: As you wish~",
                    "SWINDLER: EXITS",

                    Step.deltastage({"unit": {"key": "swashbuckler", "affiliation": "good"}}),
                    // PlotSteps.Wait(500),
                    // PlotSteps.MoveUnit({"unitKey": "swindler", "position": {"x": 25, "y": 45}}),
                    // PlotSteps.TeleportUnit({"unitKey": "swindler", "position": {"x": 37, "y": 18}}),
                    // PlotSteps.Wait(500),

                    PlotSteps.PlayAudio("Pirate:Music:PirateHaven"),
                    "SWASHBUCKLER: ENTERS 1",
                    "SWASHBUCKLER: #expression: challenge",
                    "SWASHBUCKLER: Okay! Who's first?",
                    "SQUIRE: ENTERS 3",
                    "SQUIRE: #direction: left",
                    "SQUIRE: What?? Who released the prisoner??",
                    "SQUIRE: #position: 4",
                    "SQUIRE: And who gave her a sword??",

                    Step.flag("hud", null),
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == "1.1"
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"affiliation": "good", "encounterKey": "1.1"})
                },
                "events": [
                    PlotSteps.ResetTutorialFlags(),
                    PlotSteps.HealPlayerPartyScript({"percent": 1}),
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": "1.2", "spotTag": "spawn"}),
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == "1.2"
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"affiliation": "good", "encounterKey": "1.2"})
                },
                "events": [
                    PlotSteps.ResetTutorialFlags(),
                    PlotSteps.HealPlayerPartyScript({"percent": 1}),
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": "1.3", "spotTag": "spawn"}),
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == "1.3"
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"affiliation": "good", "encounterKey": "1.3"})
                },
                "events": [
                    PlotSteps.ResetTutorialFlags(),
                    PlotSteps.HealPlayerPartyScript({"percent": 1}),
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": "2.3", "spotTag": "spawn"}),

                    // PlotSteps.EditUnit({"key": "bard", "hasBeenRemoved": false, "position": {"x": 33, "y": 20, "z": 1}}),
                    // PlotSteps.MoveUnit({"unitKey": "bard", "position": {"x": 34, "y": 20, "z": 1}}),

                    "SWINDLER: ENTERS 1",
                    "SWASHBUCKLER: ENTERS 4 #direction: left",
                    "SWINDLER: Well done~ You might take the ship yet.",
                    "SWASHBUCKLER: And where have you been?",
                    "SWINDLER: I'm with you now, aren't I? #expression: smooth",
                    "SWINDLER: My daggers are yours. #expression: neutral",

                    // PlotSteps.Dialogue({
                    //     "type": "CharacterSplash",
                    //     "data": {"unitKey": "swindler"}
                    // }),

                    PlotSteps.Dialogue({"type": "CharacterSplash", "data": {"unitKey": "swindler"}}),
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == "2.3"
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"affiliation": "good", "encounterKey": "2.3"})
                },
                "events": [
                    PlotSteps.ResetTutorialFlags(),
                    PlotSteps.HealPlayerPartyScript({"percent": 1}),
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": "2.2", "spotTag": "spawn"}),

                    "MERCENARY: ENTERS 1",
                    "MERCENARY: ...",
                    "MERCENARY: Took y'all long enough. #expression: flavor",
                    "SWASHBUCKLER: ENTERS 4",
                    "SWASHBUCKLER: #expression: happy #direction: left",
                    "SWASHBUCKLER: I found something interesting!",
                    ifUnitIsAliveAndAllied("swindler", [
                        "SWINDLER: ENTERS 3 #direction: left",
                        "SWINDLER: She found trouble. #expression: nervous"
                    ]),
                    "MERCENARY: #expression: happy",
                    "MERCENARY: Good enough for me, I suppose.",
                    PlotSteps.Dialogue({"type": "CharacterSplash", "data": {"unitKey": "mercenary"}}),
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == "2.2"
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"affiliation": "good", "encounterKey": "2.2"})
                },
                "events": [
                    "SWASHBUCKLER: Onwards, to the main deck! We take the captain and take this ship. #expression: challenge",

                    PlotSteps.ResetTutorialFlags(),
                    PlotSteps.HealPlayerPartyScript({"percent": 1}),
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": "2.1", "spotTag": "spawn"}),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return stage.currentEncounterKey == "2.1"
                        && stage.turn.number == 1
                        && stage.turn.affiliation == "bad"
                        && stage.turn.phase == "end"
                        && stage.units[PLAYER_CHARACTER].isDead != true
                },
                "events": [
                    PlotSteps.Wait(1000),
                    "KNIGHT: Why is she still alive? Can you scallywags do nothing right? #expression: angry",
                    "KNIGHT: Come, break your weapons upon me. #expression: neutral",
                    // "KNIGHT: Bring me Boots.",
                    //
                    // PlotSteps.TeleportUnit({"unitKey": "mercenary", "position": {"x": 25, "y": 18, "z": 1}}),
                    // PlotSteps.MoveUnit({"unitKey": "mercenary", "position": {"x": 25, "y": 19, "z": 1}}),
                    //
                    // "MERCENARY: You called, captain?",
                    // "KNIGHT: Take them out.",
                ]
            },
            {
                "type": "turn:every:start",
                "events": [
                    PlotSteps.ReportStartTurnAnalytics(),
                ]
            },
            {
                "type": "turn:every:end",
                "events": [
                    PlotSteps.ReportEndTurnAnalytics(),
                ]
            },
            // {
            //     "type": "before attacking",
            //     "canBeTriggered": (stage, performer, target) => {
            //         return stage.currentEncounterKey == "2.1"
            //             && target.key == "mercenary"
            //             && target.affiliation != "good"
            //             && stage.flags["hasRecruitedMercenary"] == undefined
            //     },
            //     "events": function(stage, performer, target) {
            //         let lines = {
            //             "bard": "I don't reckon so.",
            //         }
            //         let lines2 = {
            //             "bard": "And what then?",
            //             "swashbuckler": ".I will reckon him myself.",
            //             "knight": "By all the power I hold, yes."
            //         }
            //         let lines3 = {
            //             "bard": "If you please. :]",
            //             "swashbuckler": "Deal. My word is gold.",
            //             "knight": "So be it. Do not fall behind."
            //         }
            //
            //         return [
            //             "MERCENARY: ...Odds don't look good, I reckon.",
            //             performer.key.toUpperCase() + ": " + (lines[performer.key] || "What's that?"),
            //             stage.units["viking"].isDead != true && "MERCENARY: Odds are Captain Flint gets reckoned.",
            //             stage.units["viking"].isDead != true && (performer.key.toUpperCase() + ": " + lines2[performer.key] || "Yes."),
            //             "MERCENARY: " + "Let me fight alongside you. I ain't cheap, but I'll cut you a good rate.",
            //             performer.key.toUpperCase() + ": " + (lines3[performer.key] || "Yes."),
            //             Step.deltastage({"mark": 0, "unit": {"key": target.key, "affiliation": "good"}}),
            //             PlotSteps.Dialogue({"type": "CharacterSplash", "data": {"unitKey": "mercenary"}}),
            //             PlotSteps.CloseRibbitScene(),
            //         ]
            //     }
            // },
            {
                "type": "condition",
                "condition": (stage) => {
                    return stage.currentEncounterKey == "2.1"
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"affiliation": "good", "encounterKey": "2.1"})
                },
                "events": [
                    PlotSteps.PlayStinger("Pirate:Stinger:Victory"),
                    "SWASHBUCKLER: Huzzah! This ship is ours. Onwards to the treasure!! #direction: left #position: 4",

                    PlotSteps.ChapterSuccessClassic(),
                    PlotSteps.ReportSuccessAnalytics(),
                    PlotSteps.UpdateTraitorousPartyScript(),
                    PlotSteps.SaveGame({"nextChapterSlug": "wild"}),
                    {"func": () => Navigation.go("/games/pirates/chapters/wild")},
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": function(stage) {
                    return stage.units[PLAYER_CHARACTER].isDead == true
                },
                "events": [
                    PlotSteps.ChapterFailure(),
                    PlotSteps.ReportFailureAnalytics(),
                    {"func": () => App.game.chapter.restart()},
                ]
            },
            // {
            //     "type": "condition",
            //     "condition": function(stage) {
            //         return PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": "good"})
            //     },
            //     "events": [
            //         PlotSteps.ChapterFailure(),
            //         {"func": () => App.game.chapter.restart()},
            //     ]
            // },
        ]
    },
}

function ifUnitIsAliveAndAllied(unitKey, events) {
    return (stage) => {
        if(stage.units[unitKey] != undefined
        && stage.units[unitKey].isDead != true
        && stage.units[unitKey].hasBeenRemoved != true
        && stage.units[unitKey].affiliation == stage.player.affiliation) {
            return events
        }
    }
}
